import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Producto } from 'app/models/producto.models';
import { ProductoService } from 'app/services/producto.service';
import { RecetaService } from 'app/services/receta.service';
import { UmedidaService } from 'app/services/umedida.service';
import { RecetaEditCreateComponent } from '../receta-edit-create/receta-edit-create.component';
import { Recipes } from 'app/models/receta.models';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MeasurementUnit } from 'app/models/umedida.models';
import { quantity } from 'chartist';

@Component({
  selector: 'app-add-edit-insumo',
  templateUrl: './add-edit-insumo.component.html',
  styleUrls: ['./add-edit-insumo.component.css'],
})
export class AddEditInsumoComponent {
  insumosFiltrados: Producto[];
  medidas: MeasurementUnit[] = [];
  form: FormGroup;
  receta: Recipes;
  insumos: any[] = [];
  productos: Producto[] = [];
  tipo: string = 'Nuevo';
  insumo: any;
  insumoSeleccionado: any;
  modoEdicion: boolean = false;
  insumoEditado: any;

  constructor(
    private fb: FormBuilder,
    private umedidaService: UmedidaService,
    public dialogRef: MatDialogRef<AddEditInsumoComponent>,
    private articuloService: ProductoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.receta = data.receta;
    this.insumos = data.insumos || [];
    this.tipo = data.tipo || 'Nuevo';
    this.modoEdicion = !!data.insumo;
    this.insumoEditado = data.insumo;

    this.form = this.fb.group({
      articulo: [{ value: '', disabled: this.modoEdicion }, Validators.required],
      cantidad: ['', Validators.required],
      unidad: ['', Validators.required],
    });
    this.getArticulosInsumos();
    this.getUnidadesDeMedidas();
    this.insumosFiltrados = [];

    // Si es edición, cargar datos del insumo
    if (this.modoEdicion) {
      this.cargarDatosInsumo();
    } else {
      // Si es nuevo, asegurarse de que el formulario esté habilitado y limpio
      this.form.enable();
      this.form.reset({ articulo: '', cantidad: '', unidad: '' });
    }
  }

  cargarDatosInsumo() {
    if (this.insumoEditado) {
      this.form.patchValue({
        articulo: this.insumoEditado.articulo?.name || this.insumoEditado.variant.name,
        cantidad: this.insumoEditado.quantity,
        unidad:
          this.insumoEditado.measurementUnitId ||
          this.insumoEditado.unidad?.id ||
          this.insumoEditado.unidad,
      });
    }
  }

  getArticulosInsumos() {
    this.articuloService.getVariantesTipoInsumos().subscribe(
      (data: any) => {
        this.productos = data;
      },
      error => {
        console.error(error);
      }
    );
  }

  getUnidadesDeMedidas() {
    this.umedidaService.getUmedidas().subscribe(
      (data: MeasurementUnit[]) => {
        this.medidas = data;
      },
      error => {
        console.error(error);
      }
    );
  }

  agregarInsumo(data: any = { articulo: '', cantidad: 1, unidad: '' }) {
    const insumo = this.fb.group({
      articulo: [data.articulo, Validators.required],
      cantidad: [data.cantidad, [Validators.required, Validators.min(0.01)]],
      unidad: [data.unidad, Validators.required],
    });

    this.insumos.push(insumo);
  }

  filtrarInsumos($event) {
    const valor = $event.target.value;
    if (valor !== '') {
      this.insumosFiltrados = [];
      const insumos = this.productos.filter((insumo: any) => {
        return insumo.name.toLowerCase().includes(valor.toLowerCase());
      });
      this.insumosFiltrados = insumos;
    }
  }

  onSelectInsumo(insumo: MatAutocompleteSelectedEvent) {
    // buscar el insumo en la lista de productos
    this.insumoSeleccionado = this.productos.find(
      item => item.id === insumo.option.value
    );
    // setear el valor del insumo en el formulario
    this.form.controls['articulo'].setValue(this.insumoSeleccionado.name);
    
    // Si el artículo tiene una unidad de medida definida, establecerla automáticamente
    if (this.insumoSeleccionado.article && this.insumoSeleccionado.article.measurementUnitId) {
      // Establecer la unidad de medida correspondiente al artículo
      this.form.controls['unidad'].setValue(this.insumoSeleccionado.article.measurementUnitId);
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  guardar() {
    if (this.form.valid && !this.insumoEditado) {
      const unidad = this.medidas.find(item => item.id === this.form.value.unidad);

      const insumo = {
        articulo: this.form.value.articulo,
        unidad,
        quantity: this.form.value.cantidad,
        variantId: this.insumoSeleccionado.id,
        measurementUnitId: unidad.id,
      };

      insumo.articulo = this.insumoSeleccionado;

      this.dialogRef.close(insumo);
    }

    if (this.modoEdicion && this.insumoEditado) {
      const unidad = this.medidas.find(item => item.id === this.form.value.unidad);

      this.dialogRef.close({
        quantity: this.form.value.cantidad,
        measurementUnitId: unidad.id,
        unidad,
      });
    }
  }
}
